import { render, staticRenderFns } from "./coursePlay.vue?vue&type=template&id=0ae6fe08"
import script from "./coursePlay.js?vue&type=script&lang=js&external"
export * from "./coursePlay.js?vue&type=script&lang=js&external"
import style0 from "../../less/publicStyle.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./coursePlay.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports